import styled from 'styled-components';

export const ExpirationCardContainer = styled.div`
  padding: 7px 12px;
  border-radius: 10px;
  background-color: ${(props) => props.bgColor || '#fff'};
  box-shadow: 3px 4px 5px rgba(0, 0, 0, 0.5);
  width: ${(props) => (props.isMobileScreen ? '100%' : '260px')};
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
`;

export const SuggestionActionButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #5468ff;
  color: #fff;
  gap: 5px;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  min-width: 95px;
  transition: background 0.2s;

  img {
    height: 29px;
  }

  &:hover {
    background: #3b4dcc;
  }

  svg {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }
`;
